const currentYear = new Date().getFullYear()

export const CompanyContacts = () => {
  return (
    <div className="company-contacts-container">
      <div className="address">
        (c) 2015-{currentYear} Great Apps LLC <br /> 36 Maplewood Ave,
        <br /> Portsmouth, NH 03801
      </div>
      <div className="phone">
        <a href="tel:+18883052077">(888) 305-2077</a>
      </div>
    </div>
  )
}
